import {useState , useEffect} from 'react'
import styled from 'styled-components';
import LabelText from '../../../ui/LabelText';
import CustomDropdown from '../../../ui/CustomDropdown';
import IApiResponse from '../../../types/IApiResponse';
import handleApiResponse from '../../../utils/handleApiResponse';
import { IseasonData, ITransformGameModelData } from '../../../types/IClubDetail';
import { fetchData } from '../../../services/api';
import apiUrls from '../../../config/apiUrls';
import Pitch from '../../Pitch';
import { postData } from '../../../services/api';
import { IGameModel } from '../../../types/IClubDetail';
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner';
import LoadingSpinner from '../../../ui/LoadingSpinner';

const Line = styled.div`
    width: -webkit-fill-available;
    border: 1px solid #DADADA;
`

const MarketValueContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  .secondary-cta-text {
    padding-right: 0px;
  }
`;

export const teamSegmentGameModelGroup = [
    {
        title: "Defensive play",
        Segments: [
          { key: "aerial_duels", label: "Aerial duels", color:'#800000' },//
          // { key: "interceptions", label: "Interceptions" , color:'rgba(193, 247, 107, 0.85)'},//
          { key: "interceptions", label: "Interceptions" , color:'#000'},//
          { key: "fouls", label: "Fouls" , color:'rgba(133, 20, 75, 0.85)' },//
          {key:"ball_recoveries", label: "Ball recoveries" , color:'rgba(61, 153, 112, 0.85)'},//
          { key: "defensive_duels", label: "Defensive duels",color:'rgba(240, 18, 190, 0.85)' },//
        ],
    },
    {
        title: "Build up play",
        Segments: [
          { key: "crosses", label: "Crosses",color:'rgba(17, 17, 17, 0.85)' },//
          { key: "dribbles", label: "Dribbles", color:'rgba(1, 255, 112, 0.85)'},//
          { key : "accelerations", label: "Accelerations", color:'rgba(255, 179, 71, 0.85)'},//
          // { key: "aerial_duels", label: "Aerial duels", color:'rgba(255, 220, 0, 0.85)' },//
          { key: "passes", label: "Passes",color:'rgba(0, 115, 230, 0.85)' },//
          //{ key: "forward_passes", label: "Forward passes",color:'rgba(255, 65, 54, 0.85)' },//
          { key: "forward_passes", label: "Forward passes",color:'rgba(0, 255, 0, 0.85)' },//
          // { key: "through_passes", label: "Through passes", color:'rgba(127, 219, 255, 0.85)' },//
          { key: "through_passes", label: "Through passes", color:'rgba(255, 0, 0, 0.85)' },
          

        ],
    },
    {
        title: "Final third",
        Segments: [
          {key :"head_shots", label: "Head shots", color:'rgba(255, 133, 27, 0.85)'},//
          // { key: "crosses", label: "Crosses",color:'rgba(17, 17, 17, 0.85)' },//
          { key: "passes_to_final_third", label: "Passes to final third" ,color:'rgba(46, 204, 64, 0.85)'},//
          { key: "shots", label: "Shots" , color:'rgba(177, 13, 201, 0.85)'},//
          {key : "offensive_duels", label: "Offensive duels",color:'rgba(57, 204, 204, 0.85)'},//
          
          // {key: "dribbles", label: "Dribbles", color:'rgba(1, 255, 112, 0.85)'},//
          // {key : "accelerations", label: "Accelerations", color:'rgba(255, 179, 71, 0.85)'},//
          {key:"touch_in_box", label: "Touch in box", color:'rgba(227, 119, 194, 0.85)'},//
          {key: "linkup_plays", label: "Linkup plays", color:'rgba(48, 21, 2, 0.85)'},//
        ],
    }
]

interface IGameModelProps {
  teamId: number;   
}
const GameModel :React.FC<IGameModelProps> = ({teamId}) => {

    const [seasonId, setSeasonId] = useState<number>();
    const [seasonIdForAttributes, setSeasonIdForAttributes] = useState<number>();
    const [seasonData, setSeasonData] = useState<any[]>([]);
    const [seasonLabel, setSeasonLabel] = useState("");
    const [selectedAttributes, setSelectedAttributes] = useState<string[]>([
      "crosses",
      "passes_to_final_third",
      "shots",
      "defensive_duels"
    ]);
    const [gameModelData, setGameModelData] = useState<IGameModel[]>([])
    const [isGameModelLoading , setIsGameModelLoading] = useState<boolean>(false);


    useEffect(() => {
        const fetchSeasonData = async () => {
          const response: IApiResponse<IseasonData> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByTeamId"]}?TeamId=${teamId}`);
          handleApiResponse(
            response,
            (teamsData) => {
              setSeasonData(teamsData.seasonData);
              setSeasonId(teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId);
              setSeasonIdForAttributes(0);
              const matchedSeason = teamsData.seasonData.find((season) => season.value === (teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId));
              if (matchedSeason) {
                setSeasonLabel(matchedSeason.label);
              }
            },
            (error) => {
              console.error("Error fetching competition season Data:", error);
            }
          );
        };
        fetchSeasonData();
    }, [teamId]);

    const handleSeasonChange = (seasonId: string) => {
        setSeasonId(Number(seasonId));
        setSeasonIdForAttributes(Number(seasonId));
        const matchedSeason = seasonData.find((season) => season.value === seasonId);
        if (matchedSeason) {
          setSeasonLabel(matchedSeason.label);
        }
    };

    const handleGameModelAttributesSelection = (key: string) => {
        setSelectedAttributes(prev =>
          prev.includes(key)
            ? prev.filter(item => item !== key)
            : [...prev, key]
        );
    };

    const fetchGamneModelData = async () => {
        setIsGameModelLoading(true);
        try {
          const response: IApiResponse<IGameModel[]> = await postData(`${apiUrls["GetGameModel"]}`, {
            seasonId: seasonId,
            teamId: teamId,
            typeFilter: selectedAttributes
          });
    
          handleApiResponse(
            response,
            (gameModelData) => {
              setIsGameModelLoading(false);
              setGameModelData(gameModelData);
            },
            (error) => {
              setIsGameModelLoading(false);
              console.error("Error fetching Game Model Data:", error);
            }
          );
        } catch (error) {
          setIsGameModelLoading(false);
          console.error("Unexpected error while Game Model Data:", error);
        }
    };

    useEffect(()=>{
      if(teamId! > 0 && seasonId! > 0) {
        fetchGamneModelData();
      }
    },[teamId!,seasonId!,selectedAttributes])
  
  return (
    <>
    <div>
      <MarketValueContainer className="market-value-container">
                <div className="onpitch-dropdown">
                <LabelText className="drawer-title">Game Model</LabelText>
                
                  <div className="custom-dropdown season-drodown" style={{border: 'none', paddingBottom: '0px', zIndex: 8 }}>
                        <CustomDropdown
                        placeholder="SEASON"
                        options={seasonData}
                        onChange={handleSeasonChange}
                        deafaultSelected={seasonLabel}
                        isDisplaySearchInput={false}
                        Id={Number(teamId)}
                      />
                  </div>
                  </div>
                  {/* <div className="career-market-value-buttons">
                    {onthePitchOption.map(option => (
                      <SecondaryButton
                        key={option}
                        label={option}
                        isSelected={slectedTeamOnthePitchOption === option}
                        onClick={() => handleonthePitchOptionClick(option)}
                      />
                    ))}
                  </div> */}
      </MarketValueContainer>
         
        <div  className='On-pitch-container'>
          <div style={{width:'1060px',alignSelf:'center'}}>
           { isGameModelLoading && ( <ModuleSpinner/>)}
          <Pitch
              currentView='GameModel'
              gameModelData={gameModelData}
              selectedMatch={0}
              />
              </div>
              <div className='attributes-table-main'>
                  {teamSegmentGameModelGroup?.map((section, index) => (
                      <div className='attributes-group-container' key={index}>
                      <div className='group-title-container'>
                          <LabelText className='player-given-name'>{section.title}</LabelText>
                      </div>
                      <div className='group-attributes-container'>
                          {section.Segments.map((attr, idx) => (
                              <>
                                  <div className='attribute-table-selection-item' key={idx}  style={{backgroundColor : selectedAttributes.includes(attr.key)? 'white' :'transparent'}}>
                                      <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                      <input
                                          type="checkbox"
                                          id={attr.key}
                                          className="custom-checkbox"
                                          name="game_model_attribute"
                                          value={attr.key}
                                          checked={selectedAttributes.includes(attr.key)}
                                          onChange={() => handleGameModelAttributesSelection(attr.key)}
                                      />
                                      <div style={{height:'9px',width:'9px',borderRadius:'2px',background:attr.color}}></div>
                                      <LabelText style={{color:attr.color}}>{attr.label}</LabelText>
                                      </div>
                                      
                                  </div>
                                  {/* <Line/> */}
                              </>
                          ))}
                      </div>
                      </div>
                  ))}
              </div>
        </div>
       
    </div>
    </>
  )
}

export default GameModel

